import { Trans } from "@lingui/macro";
import { UiButtonBase, UiTypography } from "@smp/ui";
import { IconX } from "@tabler/icons-react";

import { useContextPolotnoTemplates } from "@/components/features/polotno_templates/context";

import { useStyles } from "./reset_filters.css";

export const ResetFilters = ({ onChange }: { onChange: () => void }) => {
  const classes = useStyles();
  const {
    state: { selectedTags },
  } = useContextPolotnoTemplates();

  if (!selectedTags.length) {
    return null;
  }

  return (
    <UiButtonBase className={classes.button} onClick={onChange}>
      <IconX className={classes.icon} size={20} />
      <UiTypography>
        <Trans>templates.filters.Clear all</Trans>
      </UiTypography>
    </UiButtonBase>
  );
};
